// extracted by mini-css-extract-plugin
module.exports = {"loginModal":"ModalUI_loginModal__bbvEs","productModal":"ModalUI_productModal__gKtAt"};